var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 761,
    height: 653,
    viewBox: "0 0 761 653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17764",
    "data-name": "Rectangle 17764",
    width: 15.038,
    height: 3.44,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17771",
    "data-name": "Rectangle 17771",
    width: 34.807,
    height: 3.441,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17774",
    "data-name": "Rectangle 17774",
    width: 56.17,
    height: 3.441,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17788",
    "data-name": "Rectangle 17788",
    width: 54.223,
    height: 3.441,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17793",
    "data-name": "Rectangle 17793",
    width: 41.247,
    height: 3.441,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17803",
    "data-name": "Rectangle 17803",
    width: 29.28,
    height: 3.441,
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17855",
    x: 176,
    y: 163,
    width: 585,
    height: 462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17825",
    x: 0,
    y: 0,
    width: 482,
    height: 653,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17761",
    "data-name": "Rectangle 17761",
    width: 147.742,
    height: 147.742,
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17764-2",
    "data-name": "Rectangle 17764",
    width: 15.038,
    height: 3.44,
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17771-2",
    "data-name": "Rectangle 17771",
    width: 34.807,
    height: 3.441,
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17774-2",
    "data-name": "Rectangle 17774",
    width: 56.17,
    height: 3.441,
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17788-2",
    "data-name": "Rectangle 17788",
    width: 54.223,
    height: 3.441,
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17793-2",
    "data-name": "Rectangle 17793",
    width: 41.247,
    height: 3.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17803-2",
    "data-name": "Rectangle 17803",
    width: 29.28,
    height: 3.441,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46887",
    "data-name": "Group 46887",
    transform: "translate(-5448.378 -4032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46397",
    "data-name": "Path 46397",
    d: "M130.386,130.334H329.7a4.549,4.549,0,0,0,4.655-4.433V23.372a4.549,4.549,0,0,0-4.655-4.435H130.386a4.549,4.549,0,0,0-4.655,4.435V125.9a4.549,4.549,0,0,0,4.655,4.433",
    transform: "translate(5588.73 4015.61)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46886",
    "data-name": "Group 46886",
    transform: "translate(-482.479 43.605)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17826",
    "data-name": "Rectangle 17826",
    width: 48.742,
    height: 3.441,
    transform: "translate(6226.705 4006.305)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46870",
    "data-name": "Group 46870",
    transform: "translate(6281.182 4006.306)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46833",
    "data-name": "Group 46833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46832",
    "data-name": "Group 46832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17763",
    "data-name": "Rectangle 17763",
    width: 15.038,
    height: 3.441,
    transform: "translate(0 -0.001)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17827",
    "data-name": "Rectangle 17827",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4006.305)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17828",
    "data-name": "Rectangle 17828",
    width: 20.609,
    height: 3.441,
    transform: "translate(6342.683 4006.305)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17829",
    "data-name": "Rectangle 17829",
    width: 34.807,
    height: 3.441,
    transform: "translate(6303.438 4006.305)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46389",
    "data-name": "Path 46389",
    d: "M122.7,298.175H65.257v3.441h69.515v-3.441Z",
    transform: "translate(6161.448 3773.195)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830",
    "data-name": "Rectangle 17830",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4071.37)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17831",
    "data-name": "Rectangle 17831",
    width: 11.362,
    height: 3.441,
    transform: "translate(6342.683 4071.37)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46871",
    "data-name": "Group 46871",
    transform: "translate(6303.438 4071.37)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46836",
    "data-name": "Group 46836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46835",
    "data-name": "Group 46835",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17770",
    "data-name": "Rectangle 17770",
    width: 34.807,
    height: 3.441,
    transform: "translate(0 0)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17832",
    "data-name": "Rectangle 17832",
    width: 9.967,
    height: 3.441,
    transform: "translate(6226.705 4017.149)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46872",
    "data-name": "Group 46872",
    transform: "translate(6241.026 4017.15)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46839",
    "data-name": "Group 46839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46838",
    "data-name": "Group 46838",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17773",
    "data-name": "Rectangle 17773",
    width: 56.169,
    height: 3.441,
    transform: "translate(0.001 0)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17833",
    "data-name": "Rectangle 17833",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4017.149)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17834",
    "data-name": "Rectangle 17834",
    width: 83.667,
    height: 3.441,
    transform: "translate(6303.438 4017.149)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17835",
    "data-name": "Rectangle 17835",
    width: 9.967,
    height: 3.441,
    transform: "translate(6226.705 4082.214)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17836",
    "data-name": "Rectangle 17836",
    width: 9.967,
    height: 3.441,
    transform: "translate(6307.416 4082.214)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46873",
    "data-name": "Group 46873",
    transform: "translate(6241.026 4082.214)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46842",
    "data-name": "Group 46842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46841",
    "data-name": "Group 46841",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17779",
    "data-name": "Rectangle 17779",
    width: 56.169,
    height: 3.441,
    transform: "translate(0.001 0)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17837",
    "data-name": "Rectangle 17837",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4082.214)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17838",
    "data-name": "Rectangle 17838",
    width: 60.985,
    height: 3.441,
    transform: "translate(6326.12 4082.214)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17839",
    "data-name": "Rectangle 17839",
    width: 30.316,
    height: 3.441,
    transform: "translate(6226.705 4027.994)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17840",
    "data-name": "Rectangle 17840",
    width: 14.761,
    height: 3.441,
    transform: "translate(6260.683 4027.994)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17841",
    "data-name": "Rectangle 17841",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4027.994)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17842",
    "data-name": "Rectangle 17842",
    width: 45.719,
    height: 3.441,
    transform: "translate(6282.202 4027.994)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46874",
    "data-name": "Group 46874",
    transform: "translate(6332.881 4027.994)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46845",
    "data-name": "Group 46845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46844",
    "data-name": "Group 46844",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17787",
    "data-name": "Rectangle 17787",
    width: 54.223,
    height: 3.441,
    transform: "translate(0 0)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17843",
    "data-name": "Rectangle 17843",
    width: 80.354,
    height: 3.441,
    transform: "translate(6226.705 4038.837)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17844",
    "data-name": "Rectangle 17844",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4038.837)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17845",
    "data-name": "Rectangle 17845",
    width: 59.317,
    height: 3.441,
    transform: "translate(6311.266 4038.837)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46875",
    "data-name": "Group 46875",
    transform: "translate(6226.705 4049.682)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46848",
    "data-name": "Group 46848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46847",
    "data-name": "Group 46847",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17792",
    "data-name": "Rectangle 17792",
    width: 41.248,
    height: 3.441,
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17846",
    "data-name": "Rectangle 17846",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4049.682)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17847",
    "data-name": "Rectangle 17847",
    width: 78.63,
    height: 3.441,
    transform: "translate(6291.953 4049.682)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17848",
    "data-name": "Rectangle 17848",
    width: 10.597,
    height: 3.441,
    transform: "translate(6376.507 4049.682)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17849",
    "data-name": "Rectangle 17849",
    width: 10.597,
    height: 3.441,
    transform: "translate(6273.433 4049.682)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17850",
    "data-name": "Rectangle 17850",
    width: 20.745,
    height: 3.441,
    transform: "translate(6226.705 4060.525)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17851",
    "data-name": "Rectangle 17851",
    width: 20.745,
    height: 3.441,
    transform: "translate(6268.531 4060.525)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17852",
    "data-name": "Rectangle 17852",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4060.525)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17853",
    "data-name": "Rectangle 17853",
    width: 53.736,
    height: 3.441,
    transform: "translate(6297.001 4060.525)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46876",
    "data-name": "Group 46876",
    transform: "translate(6357.825 4060.526)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46851",
    "data-name": "Group 46851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46850",
    "data-name": "Group 46850",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17802",
    "data-name": "Rectangle 17802",
    width: 29.28,
    height: 3.441,
    transform: "translate(0 -0.001)",
    fill: "#78849e"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17854",
    "data-name": "Rectangle 17854",
    width: 10.597,
    height: 3.441,
    transform: "translate(6253.076 4060.525)",
    fill: "#78849e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5448.38, 4032)",
    filter: "url(#Rectangle_17855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17855-2",
    "data-name": "Rectangle 17855",
    width: 387,
    height: 264,
    rx: 30,
    transform: "translate(275 242)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5448.38, 4032)",
    filter: "url(#Rectangle_17825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17825-2",
    "data-name": "Rectangle 17825",
    width: 284,
    height: 455,
    rx: 30,
    transform: "translate(99 79)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46370",
    "data-name": "Path 46370",
    d: "M413.137,115.407h-.009c.122-1.3.2-2.622.2-3.957a42.225,42.225,0,0,0-82.5-12.682c-.981-.093-1.972-.151-2.979-.151a31.119,31.119,0,0,0-19.818,7.091,42.157,42.157,0,0,0-62.055,27.544c-.013,0-.025-.009-.039-.012a30.174,30.174,0,0,0-8.121-1.094,31.263,31.263,0,0,0-18.429,56.5h98.2c.273-.274.522-.547.771-.821.422.274.819.547,1.242.821H440.879a42.192,42.192,0,0,0-27.743-73.244",
    transform: "translate(5644.135 4064.862)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "API",
    transform: "translate(5942.174 4224.65)",
    fill: "#13dbb5",
    fontSize: 47,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "API")), /*#__PURE__*/React.createElement("path", {
    id: "Path_46406",
    "data-name": "Path 46406",
    d: "M322.29,51.5a26.932,26.932,0,1,1-26.932-26.932A26.933,26.933,0,0,1,322.29,51.5",
    transform: "translate(5679.32 4031.053)",
    fill: "#17dbb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46407",
    "data-name": "Path 46407",
    d: "M300.581,46.279,281.714,35.386V57.173Z",
    transform: "translate(5685.725 4036.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46388",
    "data-name": "Path 46388",
    d: "M268.079,81.361v382.9a8.515,8.515,0,0,1-8.512,8.512H46.417a8.518,8.518,0,0,1-8.528-8.512V81.361a8.519,8.519,0,0,1,8.528-8.514h55.016a6.645,6.645,0,0,1,6.645,6.646,6.646,6.646,0,0,0,6.646,6.646h76.519a6.646,6.646,0,0,0,6.646-6.646,6.646,6.646,0,0,1,6.645-6.646h55.032a8.505,8.505,0,0,1,8.512,8.514",
    transform: "translate(5536.638 4064.606)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46869",
    className: "gear",
    "data-name": "Group 46869",
    transform: "translate(5615.507 4198.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46829",
    "data-name": "Group 46829",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46367",
    "data-name": "Path 46367",
    d: "M208.054,179.465h-8.1a60.681,60.681,0,0,0-7.087-17.66l5.966-5.966a5.4,5.4,0,0,0,0-7.638l-13.065-13.065a5.4,5.4,0,0,0-7.636,0l-5.732,5.732a61.26,61.26,0,0,0-17.5-7.494v-8.423a5.4,5.4,0,0,0-5.4-5.4H131.026a5.4,5.4,0,0,0-5.4,5.4v8.115a61.208,61.208,0,0,0-17.667,7.067L102,134.175a5.4,5.4,0,0,0-7.636,0L81.3,147.239a5.4,5.4,0,0,0,0,7.636l5.745,5.745a60.576,60.576,0,0,0-7.5,17.482H71.112a5.4,5.4,0,0,0-5.4,5.4v18.477a5.4,5.4,0,0,0,5.4,5.4h8.13A60.1,60.1,0,0,0,86.3,225.037l-5.971,5.971a5.4,5.4,0,0,0,0,7.636L93.4,251.708a5.4,5.4,0,0,0,7.636,0l5.735-5.734h0a61.109,61.109,0,0,0,17.485,7.5l.006,0v8.419a5.4,5.4,0,0,0,5.4,5.4h18.475a5.4,5.4,0,0,0,5.4-5.4V253.78h.007a60.3,60.3,0,0,0,17.648-7.067l.007,0,5.965,5.965a5.4,5.4,0,0,0,7.636,0l13.065-13.065a5.4,5.4,0,0,0,0-7.638l-5.739-5.739v0a60.632,60.632,0,0,0,7.516-17.484h8.408a5.4,5.4,0,0,0,5.4-5.4V184.865a5.4,5.4,0,0,0-5.4-5.4m-68.479,51.5a37.542,37.542,0,1,1,37.565-37.541,37.543,37.543,0,0,1-37.565,37.541",
    transform: "translate(-65.712 -119.551)",
    fill: "#3db6fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46877",
    "data-name": "Group 46877",
    transform: "translate(-611.872 399)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17826-2",
    "data-name": "Rectangle 17826",
    width: 48.742,
    height: 3.441,
    transform: "translate(6226.705 4006.305)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46870-2",
    "data-name": "Group 46870",
    transform: "translate(6281.182 4006.306)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46833-2",
    "data-name": "Group 46833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46832-2",
    "data-name": "Group 46832",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17763-2",
    "data-name": "Rectangle 17763",
    width: 15.038,
    height: 3.441,
    transform: "translate(0 -0.001)",
    fill: "#3eb6fb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17827-2",
    "data-name": "Rectangle 17827",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4006.305)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17828-2",
    "data-name": "Rectangle 17828",
    width: 20.609,
    height: 3.441,
    transform: "translate(6342.683 4006.305)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17829-2",
    "data-name": "Rectangle 17829",
    width: 34.807,
    height: 3.441,
    transform: "translate(6303.438 4006.305)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46389-2",
    "data-name": "Path 46389",
    d: "M122.7,298.175H65.257v3.441h69.515v-3.441Z",
    transform: "translate(6161.448 3773.195)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830-2",
    "data-name": "Rectangle 17830",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4071.37)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17831-2",
    "data-name": "Rectangle 17831",
    width: 11.362,
    height: 3.441,
    transform: "translate(6342.683 4071.37)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46871-2",
    "data-name": "Group 46871",
    transform: "translate(6303.438 4071.37)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46836-2",
    "data-name": "Group 46836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46835-2",
    "data-name": "Group 46835",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17770-2",
    "data-name": "Rectangle 17770",
    width: 34.807,
    height: 3.441,
    transform: "translate(0 0)",
    fill: "#3eb6fb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17832-2",
    "data-name": "Rectangle 17832",
    width: 9.967,
    height: 3.441,
    transform: "translate(6226.705 4017.149)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46872-2",
    "data-name": "Group 46872",
    transform: "translate(6241.026 4017.15)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46839-2",
    "data-name": "Group 46839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46838-2",
    "data-name": "Group 46838",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17773-2",
    "data-name": "Rectangle 17773",
    width: 56.169,
    height: 3.441,
    transform: "translate(0.001 0)",
    fill: "#3eb6fb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17833-2",
    "data-name": "Rectangle 17833",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4017.149)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17834-2",
    "data-name": "Rectangle 17834",
    width: 83.667,
    height: 3.441,
    transform: "translate(6303.438 4017.149)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17835-2",
    "data-name": "Rectangle 17835",
    width: 9.967,
    height: 3.441,
    transform: "translate(6226.705 4082.214)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17836-2",
    "data-name": "Rectangle 17836",
    width: 9.967,
    height: 3.441,
    transform: "translate(6307.416 4082.214)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46873-2",
    "data-name": "Group 46873",
    transform: "translate(6241.026 4082.214)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46842-2",
    "data-name": "Group 46842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46841-2",
    "data-name": "Group 46841",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17779-2",
    "data-name": "Rectangle 17779",
    width: 56.169,
    height: 3.441,
    transform: "translate(0.001 0)",
    fill: "#3eb6fb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17837-2",
    "data-name": "Rectangle 17837",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4082.214)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17838-2",
    "data-name": "Rectangle 17838",
    width: 60.985,
    height: 3.441,
    transform: "translate(6326.12 4082.214)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17839-2",
    "data-name": "Rectangle 17839",
    width: 30.316,
    height: 3.441,
    transform: "translate(6226.705 4027.994)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17840-2",
    "data-name": "Rectangle 17840",
    width: 14.761,
    height: 3.441,
    transform: "translate(6260.683 4027.994)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17841-2",
    "data-name": "Rectangle 17841",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4027.994)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17842-2",
    "data-name": "Rectangle 17842",
    width: 45.719,
    height: 3.441,
    transform: "translate(6282.202 4027.994)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46874-2",
    "data-name": "Group 46874",
    transform: "translate(6332.881 4027.994)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46845-2",
    "data-name": "Group 46845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46844-2",
    "data-name": "Group 46844",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17787-2",
    "data-name": "Rectangle 17787",
    width: 54.223,
    height: 3.441,
    transform: "translate(0 0)",
    fill: "#3eb6fb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17843-2",
    "data-name": "Rectangle 17843",
    width: 80.354,
    height: 3.441,
    transform: "translate(6226.705 4038.837)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17844-2",
    "data-name": "Rectangle 17844",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4038.837)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17845-2",
    "data-name": "Rectangle 17845",
    width: 59.317,
    height: 3.441,
    transform: "translate(6311.266 4038.837)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46875-2",
    "data-name": "Group 46875",
    transform: "translate(6226.705 4049.682)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46848-2",
    "data-name": "Group 46848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46847-2",
    "data-name": "Group 46847",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17792-2",
    "data-name": "Rectangle 17792",
    width: 41.248,
    height: 3.441,
    fill: "#e8f0fe"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17846-2",
    "data-name": "Rectangle 17846",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4049.682)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17847-2",
    "data-name": "Rectangle 17847",
    width: 78.63,
    height: 3.441,
    transform: "translate(6291.953 4049.682)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17848-2",
    "data-name": "Rectangle 17848",
    width: 10.597,
    height: 3.441,
    transform: "translate(6376.507 4049.682)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17849-2",
    "data-name": "Rectangle 17849",
    width: 10.597,
    height: 3.441,
    transform: "translate(6273.433 4049.682)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17850-2",
    "data-name": "Rectangle 17850",
    width: 20.745,
    height: 3.441,
    transform: "translate(6226.705 4060.525)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17851-2",
    "data-name": "Rectangle 17851",
    width: 20.745,
    height: 3.441,
    transform: "translate(6268.531 4060.525)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17852-2",
    "data-name": "Rectangle 17852",
    width: 4.126,
    height: 3.441,
    transform: "translate(6215.396 4060.525)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17853-2",
    "data-name": "Rectangle 17853",
    width: 53.736,
    height: 3.441,
    transform: "translate(6297.001 4060.525)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46876-2",
    "data-name": "Group 46876",
    transform: "translate(6357.825 4060.526)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46851-2",
    "data-name": "Group 46851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46850-2",
    "data-name": "Group 46850",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17802-2",
    "data-name": "Rectangle 17802",
    width: 29.28,
    height: 3.441,
    transform: "translate(0 -0.001)",
    fill: "#e8f0fe"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17854-2",
    "data-name": "Rectangle 17854",
    width: 10.597,
    height: 3.441,
    transform: "translate(6253.076 4060.525)",
    fill: "#e8f0fe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17856",
    "data-name": "Rectangle 17856",
    width: 77.239,
    height: 21.692,
    transform: "translate(5880.481 4537.375)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46390",
    "data-name": "Path 46390",
    d: "M347.76,351.448H221.793v-2.156a4.631,4.631,0,0,1,4.631-4.631H343.131a4.63,4.63,0,0,1,4.629,4.631Z",
    transform: "translate(5634.323 4212.318)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17857",
    "data-name": "Rectangle 17857",
    width: 582.837,
    height: 7.78,
    transform: "translate(5527.438 4563.549)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46391",
    className: "gear",
    "data-name": "Path 46391",
    d: "M326.636,253.334h-6.547a49.094,49.094,0,0,0-5.725-14.272l4.821-4.821a4.366,4.366,0,0,0,0-6.171l-10.557-10.556a4.366,4.366,0,0,0-6.171,0l-4.631,4.631a49.544,49.544,0,0,0-14.137-6.055v-6.806a4.364,4.364,0,0,0-4.363-4.363H264.4a4.364,4.364,0,0,0-4.363,4.363v6.557a49.539,49.539,0,0,0-14.275,5.71l-4.816-4.813a4.363,4.363,0,0,0-6.171,0l-10.556,10.556a4.363,4.363,0,0,0,0,6.171l4.641,4.641a48.974,48.974,0,0,0-6.057,14.127h-6.815a4.363,4.363,0,0,0-4.363,4.363v14.93a4.363,4.363,0,0,0,4.363,4.363h6.569a48.613,48.613,0,0,0,5.707,14.268l-4.824,4.822a4.363,4.363,0,0,0,0,6.171L233.993,311.7a4.36,4.36,0,0,0,6.171,0l4.634-4.631h0a49.3,49.3,0,0,0,14.127,6.057h0v6.8A4.365,4.365,0,0,0,263.3,324.3h14.929a4.364,4.364,0,0,0,4.363-4.364v-6.557h.006a48.76,48.76,0,0,0,14.259-5.71l.007-.006,4.819,4.821a4.366,4.366,0,0,0,6.171,0l10.556-10.556a4.365,4.365,0,0,0,0-6.172l-4.638-4.637,0,0a49.027,49.027,0,0,0,6.073-14.127h6.793A4.363,4.363,0,0,0,331,272.625V257.7a4.363,4.363,0,0,0-4.363-4.363M271.3,294.944a30.334,30.334,0,1,1,30.353-30.333A30.335,30.335,0,0,1,271.3,294.944",
    transform: "translate(5642.887 4154.457)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46392",
    className: "gear-reverse",
    "data-name": "Path 46392",
    d: "M384.021,250.616h-4.361a32.623,32.623,0,0,0-3.813-9.5l3.211-3.21a2.908,2.908,0,0,0,0-4.109l-7.03-7.03a2.905,2.905,0,0,0-4.109,0l-3.084,3.084a32.946,32.946,0,0,0-9.416-4.032v-4.533a2.9,2.9,0,0,0-2.9-2.9h-9.942a2.9,2.9,0,0,0-2.906,2.9v4.367a32.959,32.959,0,0,0-9.508,3.8l-3.207-3.207a2.905,2.905,0,0,0-4.109,0l-7.029,7.03a2.905,2.905,0,0,0,0,4.109l3.091,3.091a32.575,32.575,0,0,0-4.034,9.409h-4.539a2.9,2.9,0,0,0-2.906,2.9v9.942a2.906,2.906,0,0,0,2.906,2.906h4.375a32.335,32.335,0,0,0,3.8,9.5l-3.213,3.213a2.905,2.905,0,0,0,0,4.109l7.03,7.03a2.905,2.905,0,0,0,4.109,0l3.085-3.085h0a32.9,32.9,0,0,0,9.409,4.034h0v4.53a2.906,2.906,0,0,0,2.906,2.906h9.942a2.906,2.906,0,0,0,2.906-2.906v-4.366h0a32.428,32.428,0,0,0,9.5-3.8l0,0,3.21,3.21a2.905,2.905,0,0,0,4.109,0l7.03-7.03a2.905,2.905,0,0,0,0-4.109l-3.09-3.088v0a32.624,32.624,0,0,0,4.046-9.409h4.524a2.9,2.9,0,0,0,2.9-2.9v-9.942a2.906,2.906,0,0,0-2.9-2.906m-36.849,27.712a20.2,20.2,0,1,1,20.213-20.2,20.2,20.2,0,0,1-20.213,20.2",
    transform: "translate(5670.056 4102.042)",
    fill: "#0f59da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46393",
    "data-name": "Path 46393",
    d: "M421.291,280.636H374.34a4.458,4.458,0,0,1-4.458-4.458V235.34a4.458,4.458,0,0,1,4.458-4.458h46.951a4.458,4.458,0,0,1,4.458,4.458v40.839a4.458,4.458,0,0,1-4.458,4.458",
    transform: "translate(5715.352 4153.205)",
    fill: "#17dbb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46394",
    "data-name": "Path 46394",
    d: "M386.1,260.556l-10.228-7.131v-4.21l10.228-7.164v4.727l-6.356,4.517,6.356,4.566Z",
    transform: "translate(5718.24 4158.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46395",
    "data-name": "Path 46395",
    d: "M385.008,265.392l8.148-26.749h2.952l-8.148,26.749Z",
    transform: "translate(5722.641 4156.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46396",
    "data-name": "Path 46396",
    d: "M394.687,260.556v-4.695l6.356-4.566-6.356-4.517v-4.727l10.228,7.164v4.21Z",
    transform: "translate(5727.305 4158.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46401",
    "data-name": "Path 46401",
    d: "M121.835,67.348H54.5a2.123,2.123,0,0,1-2.122-2.122V24.017A2.123,2.123,0,0,1,54.5,21.9h67.335a2.122,2.122,0,0,1,2.122,2.122V65.226a2.122,2.122,0,0,1-2.122,2.122",
    transform: "translate(5481.104 4020.105)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46402",
    "data-name": "Path 46402",
    d: "M55.813,49.21l5.5-5.5a8.86,8.86,0,0,1,12.533,0l4.013,4.012a.554.554,0,0,0,.785,0l14.6-14.594a6.106,6.106,0,0,1,8.635,0l15.492,15.492a.552.552,0,0,1,.163.393V58.3a.556.556,0,0,1-.556.556H56.21a.556.556,0,0,1-.556-.556l0-8.694a.559.559,0,0,1,.163-.394",
    transform: "translate(5482.68 4024.655)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46403",
    "data-name": "Path 46403",
    d: "M68.425,34.745a3.661,3.661,0,1,1-3.662-3.662,3.661,3.661,0,0,1,3.662,3.662",
    transform: "translate(5485.308 4024.533)",
    fill: "#fff",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46404",
    "data-name": "Path 46404",
    d: "M139.791,74.93h-42.5a1.406,1.406,0,1,1,0-2.813h42.5a1.406,1.406,0,1,1,0,2.813",
    transform: "translate(5565.038 4065.518)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46405",
    "data-name": "Path 46405",
    d: "M135.388,73.682a1.688,1.688,0,1,1-1.688-1.688,1.688,1.688,0,0,1,1.688,1.688",
    transform: "translate(5582.449 4065.459)",
    fill: "#e8f0fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.882cdc39f746cb2aee5dd04168ac6d1b.svg";
export { ForwardRef as ReactComponent };